import React, {PureComponent} from 'react';
import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import TextSearch from '../../../components/TextSearch';
import * as http from '../../../modules/http';
import LoadingProgress from '../../../components/LoadingProgress';
import {
    admin_update_field,
    admin_manager_insert, admin_manager_update
} from '../../../redux/actions/AdminActions';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
import Select from '../../../components/Select';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import CheckBox from '../../../components/CheckBox';
import * as environment from "../../../modules/environment";


class EditManagerForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            showPassword: false,
            changePassword: false
        };

        this.password1 = '';
    }

    componentDidMount() {
    }

    showPassword = (e) => {
        e.preventDefault();
        this.setState({
            showPassword: !this.state.showPassword
        })
    };

    changePassword1(password) {
        this.password1 = password;
    }


    editValue(store, label, newValue) {
        this.props.dispatch(admin_update_field(store, label, newValue));
    }

    changeShowPassword = (e) => {
        this.setState({changePassword: e});
    };

    changeStoresView(e) {
        let tmp = '';

        for(let indx in e) {
            if(indx === '0') {
                tmp = String(e[indx].value)
            }
            else {
                tmp += ',' + e[indx].value
            }
        }

        this.props.dispatch(admin_update_field('managerInEdit', 'storesView', tmp));
    };

    saveManager() {

        const isAdding = (this.props.managerInEdit.id === 0);

        if (isAdding) {
            if (!this.props.managerInEdit.name || this.props.managerInEdit.name === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }

            if (!this.props.managerInEdit.username || this.props.managerInEdit.username === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectUsername});
                return;
            }

            if (!this.props.managerInEdit.password || this.props.managerInEdit.password === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.passwordMandatoryField});
                return;
            }

            if (!this.password1 || this.password1 === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseConfirmPassword});
                return;
            }

            if(this.props.managerInEdit.password !== this.password1) {
                this.setState({warning: TextManager.getCurrentTextResource().Text.passwordsAreNotTheSame});
                return;
            }
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            ...this.props.managerInEdit,
            id: this.props.managerInEdit.id,
            username: this.props.managerInEdit.username,
            name: this.props.managerInEdit.name,
            password: this.props.managerInEdit.password,
            userType: this.props.managerInEdit.userType,
            storesView: this.props.managerInEdit.storesView
            /*storeId: this.props.managerInEdit.storeId,
            storeName: this.props.stores.find(e => e.id === this.props.managerInEdit.storeId).name*/
        };

        console.log(storeData);

        var requestUrl = 'manager/update';
        if (isAdding) {
            requestUrl = 'manager/new';
        }
        http.postToServer(
            requestUrl,
            storeData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(admin_manager_insert(response.data));
                }
                else {
                    this.props.dispatch(admin_manager_update(response.data));
                }

                //this.props.dispatch(fetchUserDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    }

    render() {

        const isAdding = this.props.managerInEdit.id === 0;

        let stores = [];

        for(let indx in this.props.stores){
            stores.push({value: this.props.stores[indx].id, label: this.props.stores[indx].name});
        }

        let usersTypes = [];
        if(this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.usersTypes){
            usersTypes = this.props.utilsData.data.usersTypes.filter(u => {
                return (u.value === environment.ListUserTypesEnum.ManagerCellular || u.value === environment.ListUserTypesEnum.ManagerTVOrInternet
                    || u.value === environment.ListUserTypesEnum.ManagerCellular012 || u.value === environment.ListUserTypesEnum.ManagerAllTypes);
            }).map(a => {return {
                value: a.value,
                label: environment.ListUserNameHe.find(b => b.id === a.value).name
            }});
        }

        return (

            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <div className='card__title'>

                                {isAdding &&
                                    <h5 className='bold-text'>{TextManager.getCurrentTextResource().Settings.addManager}</h5>
                                }

                                {!isAdding &&
                                    <h5 className='bold-text'>{TextManager.getCurrentTextResource().Settings.editManager}</h5>
                                }

                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.username}</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.managerInEdit.username} noSpace
                                                    onChange={(value) => this.editValue('managerInEdit', 'username', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.managerName}</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.managerInEdit.name}
                                                    onChange={(value) => this.editValue('managerInEdit', 'name', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>סוג</label>
                                    <div className='form__form-group-field'>
                                        <Select
                                            name='select'
                                            value={this.props.managerInEdit.userType}
                                            type={"select"}
                                            select
                                            options={usersTypes}
                                            onChange={(value) => this.editValue('managerInEdit', 'userType', value.value)}
                                        >
                                        </Select>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.managerInEdit.storesView}
                                                onChange={(e) => this.changeStoresView(e)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>

                                {!isAdding && <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.changePassword}</label>
                                    <div className='form__form-group-field'>
                                        <CheckBox
                                            name='showPassword'
                                            //label={TextManager.translateDynamicText('accounts',accounts.value, accounts.value)}
                                            value={this.state.changePassword}
                                            onChange={(e) => this.changeShowPassword(e)}
                                        />
                                    </div>
                                </div>
                                }

                                {(isAdding || this.state.changePassword) &&
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.passwordField}</label>
                                    <div className='form__form-group-field'>
                                        <div className='form__form-group-icon'>
                                            <KeyVariantIcon/>
                                        </div>
                                        <input
                                            name='password'
                                            onChange={(event) => this.editValue('managerInEdit', 'password', event.target.value)}
                                            component='input'
                                            type={this.state.showPassword ? 'text' : 'password'}
                                            placeholder={TextManager.getCurrentTextResource().Settings.passwordField}
                                        />
                                        <button
                                            className={`form__form-group-button${this.state.showPassword ? ' active' : ''}`}
                                            onClick={(e) => this.showPassword(e)}><EyeIcon/></button>
                                    </div>
                                </div>
                                }

                                {(isAdding || this.state.changePassword) &&
                                <div className='form__form-group form__form-group--forgot'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.confirmPassword}</label>
                                    <div className='form__form-group-field'>
                                        <div className='form__form-group-icon'>
                                            <KeyVariantIcon/>
                                        </div>
                                        <input
                                            name='password'
                                            onChange={(event) => this.changePassword1(event.target.value)}
                                            component='input'
                                            type={this.state.showPassword ? 'text' : 'password'}
                                            placeholder={TextManager.getCurrentTextResource().Settings.PasswordField}
                                        />
                                        <button
                                            className={`form__form-group-button${this.state.showPassword ? ' active' : ''}`}
                                            onClick={(e) => this.showPassword(e)}><EyeIcon/></button>
                                    </div>
                                </div>
                                }

                            </form>

                            {this.state.error &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                    </p>
                                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                </Alert>
                            </Row>
                            }

                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>
                            }

                            {!this.state.saving &&
                            <span>
                                        <Button color='primary' size='sm'
                                                onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                        < Button color='primary' size='sm'
                                                 onClick={() => this.saveManager()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                    </span>
                            }
                            {
                                this.state.saving &&
                                <LoadingProgress/>
                            }
                        </CardBody>
                    </Card>
                </Col>

            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        managerInEdit: state.admin.managerInEdit,
        stores: state.admin.stores,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditManagerForm))